<!-- Footer -->
<footer class="footer">
				
	<!-- Footer Top -->
	<div class="footer-top">
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-3 col-md-6">
				
					<!-- Footer Widget -->
					<div class="footer-widget footer-about">
						<div class="footer-logo">
							<img src="assets/img/newlogo.png" style="max-height: 60px;" class="img-fluid" alt="logo">
						</div>
						<div class="footer-about-content">
							<p>{{'footer1' | translate}}</p>
							<!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p> -->
							<div class="social-icon">
								<ul>
									<li>
										<a href="https://www.facebook.com/mashvra" target="_blank"><i class="fab fa-facebook-f" title="Facebook"></i> </a>
									</li>
									<li>
										<a href="http://twitter.com/mashvra" target="_blank"><i class="fab fa-twitter" title="Twitter"></i> </a>
									</li>
									<li>
										<a href="http://linkedin.com/in/mashvra" target="_blank"><i class="fab fa-linkedin-in" title="Linkedin"></i></a>
									</li>
									<li>
										<a href="http://instagram.com/mashvra" target="_blank"><i class="fab fa-instagram" title="Instagram"></i></a>
									</li>
									<li>
										<!-- <a href="Javascript:;"><i class="fab fa-dribbble"></i> </a> -->
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- /Footer Widget -->
					
				</div>
				
				<div class="col-lg-3 col-md-6">
				
					<!-- Footer Widget -->
					<div class="footer-widget footer-menu">
						<h2 class="footer-title">{{'forMentee' | translate}}</h2>
						<ul>
							<!-- <li><a href="search.html">Search for Mentor</a></li> -->
							<li><a routerLink="/accounts/login">{{'login' | translate}}</a></li>
							<li><a routerLink="/accounts/register/agree/mentee">{{'register' | translate}}</a></li>
							<!-- <li><a href="booking.html">Booking</a></li> -->
							<li><a routerLink="/accounts">{{'dashboard' | translate}}</a></li>
						</ul>
					</div>
					<!-- /Footer Widget -->
					
				</div>
				
				<div class="col-lg-3 col-md-6">
				
					<!-- Footer Widget -->
					<div class="footer-widget footer-menu">
						<h2 class="footer-title">{{'forMentor' | translate}}</h2>
						<ul>
							<!-- <li><a href="appointments.html">Appointments</a></li>
							<li><a href="chat.html">Chat</a></li> -->
							<li><a routerLink="/accounts/login">{{'login' | translate}}</a></li>
							<li><a routerLink="/accounts/register/agree/mentor">{{'register' | translate}}</a></li>
							<li><a routerLink="/accounts">{{'dashboard' | translate}}</a></li>
						</ul>
					</div>
					<!-- /Footer Widget -->
					
				</div>
				
				<div class="col-lg-3 col-md-6">
				
					<!-- Footer Widget -->
					<div class="footer-widget footer-contact">
						<h2 class="footer-title">{{'contactUs' | translate}}</h2>
						<div class="footer-contact-info">
							<div class="footer-address">
								<span><i class="fas fa-map-marker-alt"></i></span>
								<p> 289 Ajmal Plaza,1st Floor
									Opp Gourmet Bakers
									Btala Colony
									Faisalabad 
								</p>
							</div>
							<p>
								<i class="fas fa-phone-alt"></i>
								+92 321 966 5502
							</p>
							<p class="mb-0">
								<i class="fas fa-envelope"></i>
								<a style="color: #fff;"  href="mailto:support@mashvra.com">support@mashvra.com</a>
							</p>
						</div>
					</div>
					<!-- /Footer Widget -->
					
				</div>
				
			</div>
		</div>
	</div>
	<!-- /Footer Top -->
	
	<!-- Footer Bottom -->
	<div class="footer-bottom">
		<div class="container-fluid">
		
			<!-- Copyright -->
			<div class="copyright">
				<div class="row">
					<div class="col-md-6 col-lg-6">
						<div class="copyright-text">
							<p class="mb-0">&copy; {{'allRights' | translate}}.</p>
						</div>
					</div>
					<div class="col-md-6 col-lg-6">
					
						<!-- Copyright Menu -->
						<div class="copyright-menu">
							<ul class="policy-menu">
								<li (click)="openModal(template)"><a href="javascript:void(0);"  >{{'Payment terms & Conditions' | translate}}</a></li>
								<li (click)="policy()" ><a href="javascript:void(0);">{{'policy' | translate}}</a></li>
								<!-- <li (click)="openModal(template1)" ><a href="javascript:void(0);">{{'policy' | translate}}</a></li> -->
								<li (click)="openModal(templateRr)" ><a href="javascript:void(0);">{{'Refunds Policy' | translate}}</a></li>
							</ul>
						</div>
						<!-- /Copyright Menu -->
						
					</div>
				</div>
			</div>
			<!-- /Copyright -->
			
		</div>
	</div>
	<!-- /Footer Bottom -->
	
</footer>
<!-- /Footer -->

<ng-template #template>
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">TERMS AND CONDITIONS </h5>
			<button type="button" class="close" (click)="decline()" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">×</span>
			</button>
		</div>
		<div class="modal-body">
			<object data="../../assets/Files/paymentterms.pdf#toolbar=0" type="application/pdf" width="100%" height="700px"></object>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="decline()" >Ok</button>
		  </div>
	</div>
  </ng-template>
  
  <ng-template #template1>
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Privacy Policy</h5>
			<button type="button" class="close" (click)="decline()" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">×</span>
			</button>
		</div>
		<div class="modal-body">
			<object data="../../assets/Files/PrivacyPolicy.pdf#toolbar=0" type="application/pdf" width="100%" height="700px"></object>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="decline()" >Ok</button>
		  </div>
	</div>
  </ng-template>

  <ng-template #templateRr>
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Refunds Policy</h5>
			<button type="button" class="close" (click)="decline()" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">×</span>
			</button>
		</div>
		<div class="modal-body">
			<object data="../../assets/Files/RefundsPolicy.pdf#toolbar=0" type="application/pdf" width="100%" height="700px"></object>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="decline()" >Ok</button>
		  </div>
	</div>
  </ng-template>